<template>
  <div>
    <div class="sf-level sf-level-between sf-pad-2">
      <div class="search">
        <input
          v-model="search"
          type="text"
          class="search-input"
          :placeholder="
            I18n.t('js.open_transactions.search_on_amount_or_reference')
          "
        />
        <div class="search-icon">
          <i class="i-search" />
        </div>
      </div>
      <p class="summary-total">
        {{ I18n.t('common.total') }}:
        {{ detailedEntries.grouped_transactions.total }}
      </p>
    </div>

    <table
      v-for="(relation, indexRelation) in filteredList"
      :key="`relation-${indexRelation}`"
      class="sf-table sf-table-border"
    >
      <tbody>
        <tr>
          <th
            class="sf-bg-primary-dark sf-c-white sf-font-l"
            :colspan="tableHeaders.length - 1"
          >
            <span>{{ relation.relation }}</span>
          </th>
          <th class="sf-bg-primary-dark sf-c-white sf-font-l">
            <span>{{ relation.total }}</span>
          </th>
        </tr>
        <tr>
          <th
            v-for="(header, headerIndex) in tableHeaders"
            :key="`header-${headerIndex}`"
            class="sf-bg-primary-darker sf-c-white"
            :class="classForHeader(header)"
            :style="styleForHeader(header)"
          >
            {{ header.text }}
          </th>
        </tr>
        <tr
          v-for="(transaction, transactionIndex) in relation.transactions"
          :key="`transaction-${transactionIndex}`"
        >
          <td
            v-for="(header, headerIndex) in tableHeaders"
            :key="`property-${transactionIndex}-${headerIndex}`"
            :class="classForHeader(header)"
            :style="styleForHeader(header)"
          >
            <open-transaction-cell
              :identifier="header.identifier"
              :value="transaction[header.identifier]"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="!filteredList.length">
      <div class="open-transactions-list-empty">
        <i class="i-search" />
        <div>{{ I18n.t('common.empty') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import openTransactionCell from './open-transaction-cell.vue'

export default {
  name: 'OpenTransactions',
  components: { openTransactionCell },

  props: {
    transactionType: {
      type: String,
      default: '',
    },
    detailedEntries: {
      type: Object,
      required: true,
    },
  },

  data: function () {
    return {
      search: '',
    }
  },
  computed: {
    filteredList() {
      //filter transactions and relations
      const searchTerm = this.search.toLowerCase()
      const relations = this.detailedEntries.grouped_transactions.relations
        .map((relation) => {
          return {
            ...relation,
            transactions: relation.transactions.filter((transaction) => {
              let match = false
              Object.keys(transaction).forEach((key) => {
                const value = transaction[key]
                match =
                  match || value.toString().toLowerCase().includes(searchTerm)
              })
              return match
            }),
          }
        })
        .filter((relation) => relation.transactions.length > 0)

      return relations
    },
    tableHeaders() {
      const { headers, translated_headers: translatedHeaders } =
        this.detailedEntries

      const availableHeadersCount = Math.min(
        headers.length,
        translatedHeaders.length
      )

      const preparedHeaders = []
      for (let i = 0; i < availableHeadersCount; i++) {
        const identifier = headers[i]
        const header = { text: translatedHeaders[i], identifier }

        if (this.isDocument(header)) {
          header.text = ''
        }

        if (identifier !== 'relation') {
          preparedHeaders.push(header)
        }
      }
      return preparedHeaders
    },
    cellWidth() {
      // total columns - 2 (value, document)
      const headersCount = this.tableHeaders.length - 2
      // 1150 = width of the modal
      // 200px for the fixed columns (value, document). Leaves 950 for rest of the cells
      const cellWidth = 950 / headersCount

      return `${cellWidth}px`
    },
  },
  methods: {
    styleForHeader(header) {
      if (!this.isDocument(header)) {
        return { width: this.cellWidth, maxWidth: this.cellWidth }
      }
    },
    classForHeader(header) {
      return {
        document: this.isDocument(header),
        value: header.identifier === 'value',
      }
    },
    isDocument(header) {
      return header.identifier === 'document_reference'
    },
  },
}
</script>
